import { LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputRef,
  message,
} from "antd";
import {
  createGroupBuyingApi,
  getGroupBuyingDetailApi,
  updateGbApi,
  updateGbIncomingApi,
} from "api/groupBuying";
import { uploadSingleFile } from "api/uploadSingleFile";
import { ReactComponent as Close } from "assets/icons/Close.svg";
import { ReactComponent as FilePlus } from "assets/icons/FilePlus.svg";
import { ReactComponent as IconSearch14 } from "assets/icons/search14.svg";
import DateRangePicker from "components/DateRangePicker";
import CsInput from "components/Input";
import ListBrandSelectSearch from "components/ListBrandSelectSearch";
import RadioUpload from "components/RadioUpload";
import UploadImageCrop from "components/UploadImageCrop";
import UploadMultiImage from "components/UploadMultiImage";
import dayjs from "dayjs";
import MainHeader from "layouts/components/Header";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { formatNumberWithCommas } from "utils/format";
import { formatTimeZone } from "utils/formatTimeZone";
import { RequiredType } from "../CampaignCreate";
import * as S from "./style";
import SelectCmp from "components/SelectCmp";
import { dataFullBank } from "utils/bankData";
import { CreateGroupBuyingApi } from "model/groupBuying";
const { TextArea } = Input;

type ProgressType = "INCOMING" | "IN_PROGRESS" | "FINISHED" | undefined;

// interface WarningType {
//   type: "" | "error" | "success" | "warning" | "validating";
//   message: string | undefined;
// }

const CampaignEdit: React.FC = () => {
  // start variables -------------------------------------------------
  const [searchParams] = useSearchParams();
  const [messageApi, contextHolder] = message.useMessage({ maxCount: 2 });
  const voucherNameRef = useRef<InputRef>(null);
  const startTimeRef = useRef<any>(null);
  const voucherSellingPriceRef = useRef<InputRef>(null);
  const navigate = useNavigate();
  const { campaignId } = useParams();
  const [form] = Form.useForm();
  const isBankingValue = Form.useWatch("isBanking", form);
  const [initProgress, setInitProgress] = useState<ProgressType>();
  const [disableField, setDisableFiled] = useState<boolean>(true);
  const [inprogressDisable, setInprogressDisable] = useState<boolean>(false);
  const [startTimeError, setStartTimeError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [endTimeError, setEndTimeError] = useState<boolean>(false);
  const [required, setRequired] = useState<RequiredType>({
    logoImage: false,
    backgroundImage: false,
    formFields: false,
  });
  // console.log('asdas')
  const values = Form.useWatch([], form);
  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        return setRequired((prev: any) => ({ ...prev, formFields: false }));
      },
      () => {
        return setRequired((prev: any) => ({ ...prev, formFields: true }));
      }
    );
  }, [form, values]);
  // end variables -------------------------------------------------------

  const errorMess = (mess: string) => {
    messageApi.open({
      type: "error",
      content: mess,
    });
  };
  // start set initial value  -------------------------------------------------------
  useEffect(() => {
    const getGroupBuyingDetail = async () => {
      try {
        if (campaignId) {
          const { data }: any = await getGroupBuyingDetailApi({
            id: +campaignId,
          });
          if (data?.voucher) {
            const initData = data.voucher;
            // console.log("initData", initData);
            // const additionalUsagePercentage =
            //   (initData?.rootAmount - initData?.targetAmount) /
            //     (initData?.targetAmount * 0.01) || 0;
            const voucherDetail = initData?.voucherDetail.map(
              (item: any) => item.url
            );

            form.setFieldsValue({
              // additionalUsagePercentage,
              voucherDetail,
              totalUsageAmount: formatNumberWithCommas(initData?.rootAmount),
              brandId: `${initData?.brandId}`,
              issuedVoucherQuantity: formatNumberWithCommas(
                initData?.quantity?.toString()
              ),
              maximumPurchaseFrequency: formatNumberWithCommas(
                initData?.maxPurchaseFrequency?.toString()
              ),
              maximumPurchaseQuantity: formatNumberWithCommas(
                initData?.maxPurchaseQuantity?.toString()
              ),
              targetSellingAmount: formatNumberWithCommas(
                initData?.targetAmount
              ),
              voucherUsageValue: formatNumberWithCommas(initData?.rootPrice),
              voucherImage: initData?.voucherImage,
              voucherName: initData?.voucherName,
              voucherSellingPrice: formatNumberWithCommas(
                initData?.voucherPrice
              ),
              startTime: dayjs(dayjs(initData?.startTime).format()),
              endTime: dayjs(dayjs(initData?.endTime).format()),
              expiredTime: dayjs(initData?.expiredTime),
              discountPercentage: formatNumberWithCommas(
                initData?.discountPercentage
              ),
              issuer: initData?.issuer,
              availableStores: initData?.availableStores,
              reservationConditions: initData?.reservationConditions,
              validityPeriod: initData?.validityPeriod,
              cancelRefundPolicy: initData?.cancelRefundPolicy,
              balanceRefundConditions: initData?.balanceRefundConditions,
              refundMethod: initData?.refundMethod,
              consumerConsultationContact:
                initData?.consumerConsultationContact,
              logoImage: {
                display: initData?.displayLogo,
                image: initData?.displayLogo ? initData?.logoImage : undefined,
              },
              backgroundImage: {
                display: initData?.displayBackground,
                image: initData?.displayBackground
                  ? initData?.backgroundImage
                  : undefined,
              },
              isBanking: initData.isBanking,
              bankAccountName: initData.bankAccountName,
              bankAccountNumber: initData.bankAccountNumber,
              bankName: initData.bankName,
            });
            if (initData.progress === "IN_PROGRESS") {
              setInprogressDisable(true);
            }
            setInitProgress(initData?.progress);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    getGroupBuyingDetail();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId]);
  /* end set initial value  ------------------------------------------------------- */

  /* start handle form  ------------------------------------------------------- */

  useEffect(() => {
    const voucherUsageValue = form.getFieldValue("voucherUsageValue");
    const issuedVoucherQuantity = form.getFieldValue("issuedVoucherQuantity");

    if (voucherUsageValue && issuedVoucherQuantity) {
      setDisableFiled(false);
    }
  }, [
    form.getFieldValue("voucherUsageValue"),
    form.getFieldValue("issuedVoucherQuantity"),
  ]);

  const onFinishFailed = (errValue: any) => {
    voucherNameRef.current!.focus({
      cursor: "end",
    });
  };

  const uploadImage = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const resp: any = await uploadSingleFile(formData);
    if (resp?.imageUrl) {
      return resp?.imageUrl;
    } else {
      return undefined;
    }
  };

  const handleUpdate = async (values: any) => {
    let voucherImageUrl =
      typeof values.voucherImage === "string"
        ? values.voucherImage
        : await uploadImage(values.voucherImage);

    let voucherDetailImagesUrl: string[] = [];
    let logoUrl =
      values.logoImage.display && values.logoImage.image
        ? typeof values.logoImage.image === "string"
          ? values.logoImage.image
          : await uploadImage(values.logoImage.image)
        : undefined;

    let backgroundImageUrl =
      values.backgroundImage.display && values.backgroundImage.image
        ? typeof values.backgroundImage.image === "string"
          ? values.backgroundImage.image
          : await uploadImage(values.backgroundImage.image)
        : undefined;

    if (values.voucherDetail) {
      await Promise.all(
        values.voucherDetail.map(async (item: any) => {
          if (item.originFileObj) {
            voucherDetailImagesUrl.push(await uploadImage(item.originFileObj));
          } else {
            voucherDetailImagesUrl.push(item.url || item);
          }
        })
      );
    }

    if (!campaignId) {
      return;
    }

    const commonUpdateData: any = {
      id: +campaignId,
      voucherImage: voucherImageUrl,
      voucherName: values.voucherName,
      endTime: formatTimeZone(values.endTime, "YYYY-MM-DD HH:mm:ss"),
      maxPurchaseQuantity: values.maximumPurchaseQuantity
        ? parseInt(values.maximumPurchaseQuantity?.replace(/,/g, ""), 10)
        : undefined,
      maxPurchaseFrequency: values.maximumPurchaseFrequency
        ? parseInt(values.maximumPurchaseFrequency?.replace(/,/g, ""), 10)
        : undefined,
      voucherDetail: voucherDetailImagesUrl,
      issuer: values.issuer || "",
      availableStores: values.availableStores || "",
      reservationConditions: values.reservationConditions || "",
      validityPeriod: values.validityPeriod || "",
      cancelRefundPolicy: values.cancelRefundPolicy || "",
      balanceRefundConditions: values.balanceRefundConditions || "",
      refundMethod: values.refundMethod || "",
      consumerConsultationContact: values.consumerConsultationContact || "",
      logoImage: values.logoImage.display ? logoUrl : undefined,
      backgroundImage: values.backgroundImage.display
        ? backgroundImageUrl
        : undefined,
      displayLogo: values.logoImage.display,
      displayBackground: values.backgroundImage.display,
      isBanking: values.isBanking || false,
      bankAccountName: values.bankAccountName || "",
      bankAccountNumber: values.bankAccountNumber || "",
      bankName: values.bankName || "",
    };

    const updateDataIncoming: any = {
      ...commonUpdateData,
      startTime: formatTimeZone(values.startTime, "YYYY-MM-DD HH:mm:00"),
      targetAmount: values.targetAmount?.replace(/,/g, ""),
      rootAmount: values.totalUsageAmount?.replace(/,/g, ""),
      voucherPrice: values.voucherSellingPrice?.replace(/,/g, ""),
      rootPrice: values.voucherUsageValue?.replace(/,/g, ""),
      expiredTime: dayjs(values.expiredTime)
        .tz("Asia/Seoul")
        .endOf("day")
        .toISOString(),
      quantity: parseInt(values.issuedVoucherQuantity?.replace(/,/g, ""), 10),
      discountPercentage: values.discountPercentage,
    };

    try {
      const { data, error }: any = campaignId
        ? initProgress === "INCOMING"
          ? await updateGbIncomingApi(updateDataIncoming)
          : await updateGbApi(commonUpdateData)
        : { data: null, error: null };

      if (error) {
        handleError(
          error,
          form,
          setLoading,
          voucherSellingPriceRef,
          startTimeRef
        );
      } else if (data) {
        navigate(`/group-buying/campaign/${campaignId}`);
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      errorMess("Update Failed!");
      setLoading(false);
    }
  };

  // const handleDuplicate = async (values: any) => {};

  const handleDuplicate = async (values: any) => {
    // console.log("values", values);

    setLoading(true);
    try {
      // upload image
      let voucherImageUrl: string = values.voucherImage;
      let voucherDetailImagesUrl: string[] = [];
      let logoUrl: string | undefined;
      let backgroundImageUrl: string | undefined;

      if (values.voucherImage) {
        voucherImageUrl = await uploadImage(values.voucherImage);
      }

      if (values.logoImage?.display && values.logoImage?.image) {
        logoUrl = await uploadImage(values.logoImage.image);
      }

      if (values.backgroundImage?.display && values.backgroundImage?.image) {
        backgroundImageUrl = await uploadImage(values.backgroundImage.image);
      }
      if (values.voucherDetail) {
        await Promise.all(
          values?.voucherDetail?.map(async (item: any) => {
            if (item.originFileObj) {
              const result = await uploadImage(item.originFileObj);
              voucherDetailImagesUrl.push(result);
            } else if (typeof item === "string") {
              voucherDetailImagesUrl.push(item);
            } else {
              voucherDetailImagesUrl.push(item.url);
            }
          })
        );
      }
      // console.log(
      //   "expiredTime",
      //   formatTimeZone(
      //     dayjs(values.expiredTime).add(1, "day").startOf("day"),
      //     "YYYY-MM-DD HH:mm:00"
      //   )
      // );

      const dataPayload: CreateGroupBuyingApi = {
        brandId: +values.brandId,
        voucherImage: voucherImageUrl || "",
        voucherName: values.voucherName,
        startTime: formatTimeZone(values.startTime, "YYYY-MM-DD HH:mm:00"),
        endTime: formatTimeZone(values.endTime, "YYYY-MM-DD HH:mm:00"),
        targetAmount: values.targetSellingAmount.replace(/,/g, ""),
        rootAmount: values.totalUsageAmount.replace(/,/g, ""),
        voucherPrice: values.voucherSellingPrice.replace(/,/g, ""),
        rootPrice: values.voucherUsageValue.replace(/,/g, ""),
        // rootPrice: "30", //
        expiredTime: dayjs(values.expiredTime)
          .tz("Asia/Seoul")
          .endOf("day")
          .toISOString(),
        quantity: parseInt(values.issuedVoucherQuantity.replace(/,/g, ""), 10),
        maxPurchaseQuantity: values.maximumPurchaseQuantity
          ? parseInt(values.maximumPurchaseQuantity.replace(/,/g, ""), 10)
          : undefined,
        maxPurchaseFrequency: values.maximumPurchaseFrequency
          ? parseInt(values.maximumPurchaseFrequency.replace(/,/g, ""), 10)
          : undefined,
        voucherDetail: voucherDetailImagesUrl,
        issuer: values.issuer || "",
        availableStores: values.availableStores || "",
        reservationConditions: values.reservationConditions || "",
        validityPeriod: values.validityPeriod || "",
        cancelRefundPolicy: values.cancelRefundPolicy || "",
        balanceRefundConditions: values.balanceRefundConditions || "",
        refundMethod: values.refundMethod || "",
        consumerConsultationContact: values.consumerConsultationContact || "",
        discountPercentage: values.discountPercentage,
        logoImage: values.logoImage?.display ? logoUrl : undefined,
        backgroundImage: values.backgroundImage?.display
          ? backgroundImageUrl
          : undefined,
        displayLogo: values.logoImage?.display,
        displayBackground: values.backgroundImage?.display,
        isBanking: values.isBanking,
        bankAccountName: values.bankAccountName || "",
        bankAccountNumber: values.bankAccountNumber || "",
        bankName: values.bankName || "",
      };

      //create Group Buying
      const { data, error }: any = await createGroupBuyingApi(dataPayload);
      if (error) {
        errorMess("Create Group Buying Failed!");
        if (error.errorCode === "INVALID_PERCENTAGE") {
          form.setFields([
            {
              name: "voucherSellingPrice",
              errors: [
                "Voucher selling price must less or equal to voucher usage value",
              ],
            },
          ]);
          if (voucherSellingPriceRef.current) {
            voucherSellingPriceRef.current.focus();
          }
        } else if (error.errorCode === "DUPLICATE_TIME") {
          form.setFields([
            {
              name: "startTime",
              errors: ["Campaign times cannot overlap"],
            },
          ]);
          if (startTimeRef.current) {
            startTimeRef.current.focus();
          }
        }
        setLoading(false);
        return;
      }
      if (data) {
        navigate("/group-buying/campaign");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      errorMess("Create Group Buying Failed!");
      setLoading(false);
    }
  };

  const handleError = (
    error: any,
    form: any,
    setLoading: any,
    voucherSellingPriceRef: any,
    startTimeRef: any
  ) => {
    errorMess("Update Failed!");
    if (error.errorCode === "INVALID_PERCENTAGE") {
      form.setFields([
        {
          name: "voucherSellingPrice",
          errors: [
            "Voucher selling price must be less or equal to voucher usage value",
          ],
        },
      ]);
      voucherSellingPriceRef.current?.focus();
    } else if (error.errorCode === "DUPLICATE_TIME") {
      form.setFields([
        { name: "startTime", errors: ["Campaign times cannot overlap"] },
      ]);
      startTimeRef.current?.focus();
    }
    setLoading(false);
  };

  const onReset = () => {
    form.resetFields();
    navigate(`/group-buying/campaign/${campaignId}`);
  };

  const onFill = () => {
    // form.setFieldsValue({ note: "Hello world!", gender: "male" });
  };
  /* end handle form  ------------------------------------------------------- */

  /* start auto calculate  ---------------------------------------------------------- */
  const calculateTotalUsageAmount = () => {
    const voucherUsageValue = form.getFieldValue("voucherUsageValue");
    const issuedVoucherQuantity = form.getFieldValue("issuedVoucherQuantity");
    if (voucherUsageValue && issuedVoucherQuantity) {
      const totalUsageAmount =
        parseInt(voucherUsageValue.replace(/,/g, ""), 10) *
        parseInt(issuedVoucherQuantity.replace(/,/g, ""), 10);
      form.setFieldsValue({
        totalUsageAmount: formatNumberWithCommas(totalUsageAmount.toString()),
      });

      setDisableFiled(false);
    } else {
      setDisableFiled(true);
      form.setFieldsValue({
        totalUsageAmount: undefined,
        discountPercentage: undefined,
        voucherSellingPrice: undefined,
        targetSellingAmount: undefined,
      });
    }
  };

  const calculateTargetSellingAmount = () => {
    const voucherSellingPrice = form.getFieldValue("voucherSellingPrice");
    const issuedVoucherQuantity = form.getFieldValue("issuedVoucherQuantity");

    if (voucherSellingPrice && issuedVoucherQuantity) {
      const targetSellingAmount =
        parseInt(voucherSellingPrice.replace(/,/g, ""), 10) *
        parseInt(issuedVoucherQuantity.replace(/,/g, ""), 10);
      form.setFieldsValue({
        targetSellingAmount: formatNumberWithCommas(
          targetSellingAmount.toString(),
          true
        ),
      });
    }
  };

  const onBlurDiscountPercentage = () => {
    const voucherUsageValue = form.getFieldValue("voucherUsageValue");
    const discountPercentage = form.getFieldValue("discountPercentage");

    if (voucherUsageValue && discountPercentage) {
      const voucherSellingPrice =
        (parseInt(voucherUsageValue.replace(/,/g, ""), 10) *
          (100 - parseInt(discountPercentage.replace(/,/g, ""), 10))) /
        100;

      form.setFieldsValue({
        voucherSellingPrice: formatNumberWithCommas(
          voucherSellingPrice.toString(),
          true
        ),
      });
    }
  };

  const onBlurVoucherSellingPrice = () => {
    const voucherUsageValue = form.getFieldValue("voucherUsageValue");
    const voucherSellingPrice = form.getFieldValue("voucherSellingPrice");
    if (voucherUsageValue && voucherSellingPrice) {
      const discountPercentage =
        ((parseInt(voucherUsageValue.replace(/,/g, ""), 10) -
          parseInt(voucherSellingPrice.replace(/,/g, ""), 10)) /
          parseInt(voucherUsageValue.replace(/,/g, ""), 10)) *
        100;

      form.setFieldsValue({
        discountPercentage: formatNumberWithCommas(
          discountPercentage.toFixed().toString()
        ),
      });
      if (
        parseInt(voucherSellingPrice.replace(/,/g, ""), 10) >
        parseInt(voucherUsageValue.replace(/,/g, ""), 10)
      ) {
        form.setFields([
          {
            name: "voucherSellingPrice",
            errors: [
              "Voucher selling price must less or equal to voucher usage value",
            ],
          },
        ]);
      }
    }
  };

  const onBlurVoucherUsageValue = () => {
    const voucherUsageValue = form.getFieldValue("voucherUsageValue");
    const voucherSellingPrice = form.getFieldValue("voucherSellingPrice");

    if (voucherUsageValue && voucherSellingPrice) {
      const voucherUsageValueNumber = parseInt(
        voucherUsageValue.replace(/,/g, ""),
        10
      );
      const voucherSellingPriceNumber = parseInt(
        voucherSellingPrice.replace(/,/g, ""),
        10
      );
      if (voucherUsageValueNumber <= voucherSellingPriceNumber) {
        form.setFields([
          {
            name: "voucherUsageValue",
            errors: [
              "Voucher usage value must larger or equal to voucher selling price",
            ],
          },
        ]);
      } else {
        const discountPercentageNumber =
          ((voucherUsageValueNumber - voucherSellingPriceNumber) /
            voucherUsageValueNumber) *
          100;
        console.log(discountPercentageNumber);

        form.setFieldsValue({
          discountPercentage: formatNumberWithCommas(
            discountPercentageNumber.toFixed().toString()
          ),
        });
      }
    }
  };
  /* end auto calculate  ---------------------------------------------------------- */

  /* start format date  ---------------------------------------------------------- */
  const handleValuesChange = (changedValues: any, allValues: any) => {
    if (
      "startTime" in changedValues ||
      "endTime" in changedValues ||
      "expiredTime" in changedValues
    ) {
      const startTime = allValues.startTime;
      const endTime = allValues.endTime;
      const expiredTime = allValues.expiredTime;

      const setField = (name: string, error: string[]) => {
        form.setFields([{ name, errors: error }]);
      };

      setStartTimeError(
        startTime && endTime ? !startTime.isBefore(endTime) : false
      );
      setField(
        "startTime",
        startTime && endTime && !startTime.isBefore(endTime)
          ? ["Start time must be before end time"]
          : []
      );

      setEndTimeError(
        endTime && expiredTime ? endTime.isAfter(expiredTime) : false
      );
      setField(
        "endTime",
        endTime && expiredTime && endTime.isAfter(expiredTime)
          ? ["End time must be before voucher expiry date"]
          : []
      );
    }
  };

  const range = (start: number, end: number) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDateTime = (value: any) => {
    const startValue = form.getFieldValue("startTime");
    const valueCheck = dayjs(value).format("YYYY-MM-DD");
    if (valueCheck !== dayjs(startValue).format("YYYY-MM-DD")) {
      return {};
    }

    return {
      disabledHours: () => {
        if (!startValue) {
          return [];
        }
        return range(0, startValue.hour());
      },
      disabledMinutes: (selectedHour: number) => {
        if (!startValue) {
          return [];
        }
        return startValue.hour() === selectedHour
          ? range(0, startValue.minute())
          : [];
      },
      disabledSeconds: (selectedHour: number, selectedMinute: number) => {
        if (!startValue) {
          return [];
        }

        const isSameMinute =
          startValue.hour() === selectedHour &&
          startValue.minute() === selectedMinute;

        return isSameMinute ? range(0, startValue.second() + 1) : [];
      },
    };
  };

  /* end format date  ---------------------------------------------------------- */

  return (
    <S.Wrapper>
      {contextHolder}
      <MainHeader backLink="/group-buying/campaign" title="수정하기" />
      <Form
        // onFinish={handleCreate}
        onFinish={(values) => {
          if (searchParams.get("action") === "duplicate") {
            handleDuplicate(values);
          } else {
            handleUpdate(values);
          }
        }}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
        className="form-content"
        form={form}
        onValuesChange={handleValuesChange}
      >
        <S.Block>
          <Form.Item>
            <p className="block-title">프리미엄 멤버십 정보</p>
          </Form.Item>
          <Form.Item
            name="brandId"
            label="발급할 브랜드 선택"
            rules={[{ required: true, message: "발급할 브랜드 선택" }]}
          >
            <ListBrandSelectSearch
              onChange={(v: string) =>
                v === "clear"
                  ? form.resetFields(["brandId"])
                  : form.setFieldValue("brandId", v)
              }
              iconWhenOpen={<IconSearch14 />}
              hiddenClear={inprogressDisable}
              disabled={inprogressDisable}
              defaultValue={form.getFieldValue("brandId")}
            />
          </Form.Item>
          <S.WrapUpload>
            <Form.Item
              name="logoImage"
              label="중앙 (로고 위치) 이미지 등록"
              style={{
                width: "50%",
                borderRight: "1px solid #ccc",
              }}
            >
              <RadioUpload
                onChange={(e) => {
                  form.setFieldValue("logoImage", e);
                }}
                setRequired={(e) =>
                  setRequired((prev: any) => ({ ...prev, logoImage: e }))
                }
                defaultValue={{
                  display: form.getFieldValue("logoImage")?.display,
                  image: form.getFieldValue("logoImage")?.image,
                }}
                labelTop="브랜드 로고로 적용"
              />
            </Form.Item>
            <Form.Item
              name="backgroundImage"
              label="배경 이미지 등록"
              // rules={[{ required: true, message: "This field is required." }]}
              style={{
                width: "50%",
                paddingLeft: 16,
              }}
            >
              <RadioUpload
                onChange={(e) => {
                  form.setFieldValue("backgroundImage", e);
                }}
                setRequired={(e) =>
                  setRequired((prev: any) => ({
                    ...prev,
                    backgroundImage: e,
                  }))
                }
                defaultValue={{
                  display: form.getFieldValue("backgroundImage")?.display,
                  image: form.getFieldValue("backgroundImage")?.image,
                }}
                labelTop="디폴트 배경으로 적용"
              />
            </Form.Item>
          </S.WrapUpload>
          <Form.Item
            name="voucherImage"
            label="썸네일 이미지"
            // rules={[
            //   { required: true, message: "썸네일 이미지를 등록해 주세요" },
            // ]}
          >
            <>
              <p className="img-size">600*600px 등 1:1 비율을 권장합니다</p>
              <UploadImageCrop
                initImage={form.getFieldValue("voucherImage")}
                onImageChange={(file: File) => {
                  form.setFieldsValue({ voucherImage: file });
                }}
                crop={{ type: "rect", aspect: 1 }}
              />
            </>
          </Form.Item>
          <Form.Item
            name="voucherName"
            label="프리미엄 멤버십 발급 명"
            rules={[
              {
                required: true,
                message: "발급할 프리미엄 멤버십 이름을 써주세요",
              },
              {
                min: 3,
                message: "세글자 이상 입력해 주세요",
              },
            ]}
          >
            <CsInput
              ref={voucherNameRef}
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="입력해 주세요"
              // onChange={(e) => setTextSearch(e.target.value)}
              onBlur={(e) =>
                form.setFieldsValue({
                  voucherName: e.target.value.trim().replace(/\s+/g, " "),
                })
              }
            />
          </Form.Item>
        </S.Block>

        <S.Block>
          <Form.Item>
            <p className="block-title">
              발급 정보 (사용할 수 있는 기간은 발급이 끝난 직후부터 사용
              종료일까지입니다)
            </p>
          </Form.Item>

          <Form.Item>
            <Form.Item
              name="startTime"
              label="발급 시작 날짜"
              style={{ display: "inline-block", width: "calc(50% - 15px)" }}
              rules={[
                { required: true, message: "판매를 시작할 날짜를 정하세요" },
                {
                  validator: (_, value) => {
                    if (startTimeError) {
                      return Promise.reject(
                        "The start time must be less than the end time"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <>
                <DatePicker
                  ref={startTimeRef}
                  disabled={
                    searchParams.get("action") !== "duplicate" &&
                    inprogressDisable
                  }
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  placeholder="발급 날짜를 선택하세요"
                  disabledDate={(current) =>
                    current && current.isBefore(dayjs(), "day")
                  }
                  defaultValue={dayjs(form.getFieldValue("startTime"))}
                />
              </>
            </Form.Item>
            <Form.Item
              name="endTime"
              label="발급 마감 날짜"
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
                margin: "0 0 0 30px",
              }}
              rules={[
                { required: true, message: "판매를 종료할 날짜를 정하세요" },
                {
                  validator: (_, value) => {
                    if (endTimeError) {
                      return Promise.reject(
                        "End time must be before voucher expiry date"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <DatePicker
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD HH:mm"
                placeholder="마감 날짜를 선택하세요"
                disabledDate={(currentDate) => {
                  const startTime = dayjs(
                    form.getFieldValue("startTime")
                  ).format();
                  return (
                    !startTime ||
                    dayjs(currentDate).isBefore(dayjs(startTime, "YYYY-MM-DD"))
                  );
                }}
                disabledTime={disabledDateTime}
                defaultValue={dayjs(form.getFieldValue("endTime"))}
              />
            </Form.Item>
          </Form.Item>
        </S.Block>

        <S.Block>
          <Form.Item>
            <p className="block-title">프리미엄 멤버십 가격 설정</p>
          </Form.Item>

          <Form.Item>
            <Form.Item
              name="voucherUsageValue"
              label="원가"
              rules={[
                {
                  required: true,
                  message: "가격을 써주세요",
                },
              ]}
              // validateStatus={warning?.type}
              // help={warning?.message}
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
              }}
            >
              <CsInput
                disabled={
                  searchParams.get("action") !== "duplicate" &&
                  inprogressDisable
                }
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="ex) 100,000"
                onChange={(e) => {
                  const formattedValue = formatNumberWithCommas(e.target.value);
                  form.setFieldValue("voucherUsageValue", formattedValue);
                }}
                // onBlur={onBlurVoucherUsageValue}
                onBlur={() => {
                  calculateTotalUsageAmount();
                  onBlurVoucherUsageValue();
                }}
                suffix={<p className="unit">원</p>}
              />
            </Form.Item>
            <Form.Item
              name="issuedVoucherQuantity"
              label="판매 수량"
              rules={[
                {
                  required: true,
                  message: "수량을 써주세요",
                },
              ]}
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
                margin: "0 0 0 30px",
              }}
            >
              <CsInput
                disabled={
                  searchParams.get("action") !== "duplicate" &&
                  inprogressDisable
                }
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="ex) 1,000"
                onChange={(e) => {
                  const formattedValue = formatNumberWithCommas(e.target.value);
                  form.setFieldValue("issuedVoucherQuantity", formattedValue);
                }}
                onBlur={() => {
                  calculateTotalUsageAmount();
                  calculateTargetSellingAmount();
                }}
                suffix={<p className="unit">개</p>}
              />
            </Form.Item>
          </Form.Item>

          <Form.Item
            name="totalUsageAmount"
            label="합"
            rules={[
              {
                required: true,
                message: "Total usage amount is required",
              },
            ]}
          >
            <CsInput
              disabled={true}
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="자동 계산 됩니다"
              onChange={(e) => {
                const formattedValue = formatNumberWithCommas(e.target.value);
                form.setFieldValue("totalUsageAmount", formattedValue);
              }}
              // onBlur={onBlurTotalUsageAmount}
              suffix={<p className="unit">원</p>}
            />
          </Form.Item>

          <Form.Item
            name="discountPercentage"
            label="할인율로 설정"
            rules={[
              {
                required: true,
                message: "Discount percentage is required",
              },
            ]}
          >
            <CsInput
              disabled={
                searchParams.get("action") !== "duplicate" &&
                (inprogressDisable || disableField)
              }
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="ex) 10%"
              onChange={(e) => {
                let inputValue = e.target.value;
                const numericValue = parseFloat(
                  inputValue.replace(/[^0-9.]/g, "")
                );
                const clampedValue = Math.min(100, Math.max(0, numericValue));
                const formattedValue = formatNumberWithCommas(
                  clampedValue.toString(),
                  true
                );
                form.setFieldValue("discountPercentage", formattedValue);
              }}
              onBlur={() => {
                onBlurDiscountPercentage();
                calculateTargetSellingAmount();
              }}
              suffix={<p className="unit">%</p>}
            />
          </Form.Item>

          <Form.Item>
            <Form.Item
              name="voucherSellingPrice"
              label="할인가로 설정"
              style={{ display: "inline-block", width: "calc(50% - 15px)" }}
              rules={[
                {
                  required: true,
                  message: "Voucher selling price is required",
                },
              ]}
            >
              <CsInput
                ref={voucherSellingPriceRef}
                disabled={
                  searchParams.get("action") !== "duplicate" &&
                  (inprogressDisable || disableField)
                }
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="ex) 90,000"
                onChange={(e) => {
                  const formattedValue = formatNumberWithCommas(
                    e.target.value,
                    true
                  );
                  form.setFieldValue("voucherSellingPrice", formattedValue);
                }}
                onBlur={() => {
                  onBlurVoucherSellingPrice();
                  calculateTargetSellingAmount();
                }}
                suffix={<p className="unit">원</p>}
              />
            </Form.Item>
            <Form.Item
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
                margin: "0 0 0 30px",
              }}
              name="targetSellingAmount"
              label="Target selling amount"
              rules={[
                {
                  required: true,
                  message: "Target selling amount is required",
                },
              ]}
            >
              <CsInput
                disabled={true}
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="ex) 90,000,000"
                onChange={(e) => {
                  const formattedValue = formatNumberWithCommas(
                    e.target.value,
                    true
                  );
                  form.setFieldValue("targetSellingAmount", formattedValue);
                }}
                suffix={<p className="unit">원</p>}
              />
            </Form.Item>
          </Form.Item>

          <Form.Item
            name="expiredTime"
            label="프리미엄 멤버십 사용 종료일"
            style={{ display: "inline-block", width: "calc(50% - 15px)" }}
            rules={[
              {
                required: true,
                message: "사용 종료일을 정하세요",
              },
            ]}
          >
            <DateRangePicker
              disabled={
                searchParams.get("action") !== "duplicate" && inprogressDisable
              }
              defaultValue={dayjs(form.getFieldValue("expiredTime"))}
              onChange={(v, d) => {
                console.log("v", v);
                console.log("d", d);
              }}
              format="YYYY-MM-DD"
              placeholder="종료 날짜를 선택하세요"
              disabledDate={(currentDate) => {
                const endTime = form.getFieldValue("endTime");
                const endTimeFormat = dayjs(endTime).format("YYYY-MM-DD");
                return (
                  !endTime ||
                  dayjs(currentDate).isBefore(
                    dayjs(endTimeFormat).add(1, "day")
                  )
                );
              }}
            />
          </Form.Item>
        </S.Block>

        <S.Block>
          <Form.Item>
            <p className="block-title">
              사용 조건 (일반적인 발급인 경우 미설정)
            </p>
          </Form.Item>
          <Form.Item>
            <Form.Item
              name="maximumPurchaseQuantity"
              label="최대 구매 수량"
              style={{ display: "inline-block", width: "calc(50% - 15px)" }}
            >
              <CsInput
                // defaultValue="inactive"
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="ex) 10"
                onChange={(e) => {
                  const formattedValue = formatNumberWithCommas(e.target.value);
                  form.setFieldValue("maximumPurchaseQuantity", formattedValue);
                }}
                suffix={<p className="unit">개</p>}
              />
            </Form.Item>
            <Form.Item
              name="maximumPurchaseFrequency"
              label="구매 횟수 제한"
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
                margin: "0 0 0 30px",
              }}
            >
              <CsInput
                // defaultValue="inactive"
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="ex) 3"
                onChange={(e) => {
                  const formattedValue = formatNumberWithCommas(e.target.value);
                  form.setFieldValue(
                    "maximumPurchaseFrequency",
                    formattedValue
                  );
                }}
                suffix={<p className="unit">회</p>}
              />
            </Form.Item>
          </Form.Item>
        </S.Block>

        <S.Block>
          {/* <Form.Item>
            <p className="block-title">
              신용카드 결제가 아닌 무통장 입금으로 전환하기 (원하는 경우
              체크해주세요)
            </p>
          </Form.Item> */}
          <Form.Item
            initialValue={{ isBanking: form.getFieldValue("isBanking") }}
            name="isBanking"
          >
            <Checkbox
              checked={form.getFieldValue("isBanking")}
              onChange={(e) => {
                form.setFieldValue("isBanking", e.target.checked);
                if (!e.target.checked) {
                  form.setFields([
                    {
                      name: "bankName",
                      errors: [],
                    },
                    {
                      name: "bankAccountNumber",
                      errors: [],
                    },
                    {
                      name: "bankAccountName",
                      errors: [],
                    },
                  ]);
                }
              }}
            >
              신용카드 결제가 아닌 무통장 입금으로 전환하기 (원하는 경우
              체크해주세요)
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <Form.Item
              name="bankName"
              label="은행 선택"
              style={{ display: "inline-block", width: "calc(50% - 15px)" }}
              rules={[
                {
                  required: isBankingValue,
                  message: "This field is required",
                },
              ]}
            >
              <SelectCmp
                disabled={
                  searchParams.get("action") !== "duplicate" && !isBankingValue
                }
                style={{
                  width: "100%",
                  height: 48,
                }}
                options={dataFullBank}
                placeholder="입금받을 은행을 선택하세요"
                onChange={(v) => {
                  const bankName = dataFullBank.find(
                    (item: any) => item.value === v
                  );
                  form.setFieldValue("bankName", bankName?.label);
                }}
              />
            </Form.Item>
            <Form.Item
              name="bankAccountNumber"
              label="계좌번호"
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
                margin: "0 0 0 30px",
              }}
              rules={[
                {
                  required: isBankingValue,
                  message: "This field is required",
                },
              ]}
            >
              <CsInput
                // defaultValue="inactive"
                disabled={
                  searchParams.get("action") !== "duplicate" && !isBankingValue
                }
                style={{
                  width: "100%",
                  height: 48,
                }}
                placeholder="계좌번호를 입력하세요"
              />
            </Form.Item>
          </Form.Item>
          <Form.Item
            name="bankAccountName"
            label="예금주"
            style={{
              display: "inline-block",
              width: "calc(50% - 15px)",
            }}
            rules={[
              {
                required: isBankingValue,
                message: "This field is required",
              },
            ]}
          >
            <CsInput
              // defaultValue="inactive"
              disabled={!isBankingValue}
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="예금주를 입력하세요"
            />
          </Form.Item>
        </S.Block>

        <S.Block>
          <Form.Item>
            <p className="block-title">프리미엄 멤버십 상세 페이지</p>
          </Form.Item>

          <Form.Item name="voucherDetail">
            <UploadMultiImage
              initData={form.getFieldValue("voucherDetail")}
              // onChange={(file) => {
              //   setImagesDetail(file);
              // }}
            />
          </Form.Item>
        </S.Block>

        <S.Block>
          <Form.Item>
            <p className="block-title">발급자 정보</p>
          </Form.Item>

          <Form.Item
            name="issuer"
            label="발급자"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`이 프리미엄 멤버십을 발행하는 주최자 (회사 명)${"\n"}ex) 삼성`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="availableStores"
            label="이용 가능한 매장"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`해당 프리미엄 멤버십을 사용할 수 있는 매장${"\n"}ex) 삼성 서비스센터 대치점, 삼성 서비스센터 강남점`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="reservationConditions"
            label="사용 조건"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`프리미엄 멤버십을 사용을 할 수 있는 조건${"\n"}ex) 프리미엄 멤버십 회원 로그인 후 QR코드를 제시하세요`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="validityPeriod"
            label="프리미엄 멤버십 유효 기간"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`프리미엄 멤버십의 유효한 기간${"\n"}ex) 지정된 마감일까지 사용 가능합니다.`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="cancelRefundPolicy"
            label="취소/환불 조건"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`프리미엄 멤버십의 취소 및 환불 가능한 조건${"\n"}ex) 미사용 7일이내의 취소 및 환불이 가능합니다.`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="balanceRefundConditions"
            label="잔액 환불 정책"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`프리미엄 멤버십 사용 후의 환불 정책${"\n"}ex) 한번이라도 사용한 경우 환불이 불가능합니다.`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="refundMethod"
            label="환불 방법"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`환불 방법${"\n"}ex) 모아프렌즈 내 1:1 게시판을 통해 환불 신청 (구매자명, 구매 날짜, 구매한 프리미엄 멤버십명 기재, 사유 기재)`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>

          <Form.Item
            name="consumerConsultationContact"
            label="고객센터"
            rules={[
              {
                max: 300,
                message: "Please enter max 300 characters",
              },
            ]}
          >
            <TextArea
              placeholder={`문의 연락처${"\n"}ex) 모아프렌즈 1:1 게시판 문의`}
              rows={3}
              style={{ color: "#2D2D2D" }}
              onBlur={() => {
                const currentValue = form.getFieldValue("issuer");
                const processedValue = currentValue
                  ?.split("\n")
                  ?.map((line: string) => line?.trim()?.replace(/\s+/g, " "))
                  ?.join("\n");
                form.setFieldsValue({ issuer: processedValue });
              }}
            />
          </Form.Item>
        </S.Block>

        <Form.Item className="group-btn">
          <Button
            onClick={onReset}
            htmlType="submit"
            className="btn btn-cancel"
            icon={<Close />}
          >
            Cancel
          </Button>
          {loading ? (
            <Button className="btn btn-create">
              <LoadingOutlined />
            </Button>
          ) : (
            <Button
              onClick={onFill}
              htmlType="submit"
              className="btn btn-create"
              icon={<FilePlus />}
              disabled={
                required.backgroundImage ||
                required.logoImage ||
                required.formFields
              }
              style={
                required.backgroundImage ||
                required.logoImage ||
                required.formFields
                  ? {
                      backgroundColor: "#e5e5e5",
                      opacity: 0.7,
                    }
                  : {}
              }
            >
              {searchParams.get("action") === "duplicate"
                ? "Duplicate"
                : "Save"}
            </Button>
          )}
        </Form.Item>
      </Form>
    </S.Wrapper>
  );
};

export default CampaignEdit;
